var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65.0 65.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,0 C50.4492544,0 65,14.5507456 65,32.5 C65,50.4492544 50.4492544,65 32.5,65 C14.5507456,65 0,50.4492544 0,32.5 C0,14.5507456 14.5507456,0 32.5,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i1",
    x1: "0px",
    y1: "32.5px",
    x2: "65px",
    y2: "32.5px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215AEA",
    offset: "25.5035635%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174CD6",
    offset: "49.8843619%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EC1",
    offset: "74.5787166%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0030AC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97619048,0 C7.72446459,0 9.95238095,2.22791636 9.95238095,4.97619048 C9.95238095,7.72446459 7.72446459,9.95238095 4.97619048,9.95238095 C2.22791636,9.95238095 0,7.72446459 0,4.97619048 C0,2.22791636 2.22791636,0 4.97619048,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9417882,0.0283570137 C31.3801836,-0.0583107917 31.8343492,0.0559736432 32.1795117,0.339812854 C32.5246742,0.623652064 32.7245287,1.04719132 32.7241696,1.4940713 C32.7087186,2.24510522 32.1619024,2.87926009 31.421312,3.00502368 C28.1814608,3.5955387 24.9095819,3.99432726 21.6227405,4.19930939 C20.9767916,4.24197993 20.3766839,4.547961 19.9627612,5.04569457 C19.5488384,5.54342815 19.3574001,6.18926483 19.4332167,6.83216654 L19.7136929,9.33835701 C20.1585777,13.2539498 21.0698004,17.102347 22.4279786,20.8016903 L24.2375024,25.6421665 C24.3763381,26.0162754 24.3586394,26.4305364 24.1884016,26.7914406 C24.0181637,27.1523449 23.7097369,27.4294699 23.3327405,27.5602618 C23.1683425,27.6246053 22.9935615,27.6583349 22.8170263,27.6597856 C22.2311889,27.6490373 21.706538,27.2945434 21.4779786,26.7550237 L21.0165501,25.7688332 C19.568931,22.6564523 18.2208358,19.5169284 16.9903596,16.3231189 C16.8904805,16.0653854 16.6424837,15.8955238 16.3660739,15.8955238 C16.0896641,15.8955238 15.8416673,16.0653854 15.7417882,16.3231189 C14.511312,19.5169284 13.1632167,22.6745475 11.7155977,25.7597856 L11.2722643,26.6645475 L11.2153273,26.7967682 C10.8814846,27.4801953 10.0762478,27.8104126 9.3496453,27.5376427 C8.57763012,27.2478247 8.18673207,26.3870389 8.47655006,25.6150237 L10.2860739,20.7745475 C11.6486909,17.0765407 12.5600416,13.2276027 13.0003596,9.31121416 L13.2898834,6.82311892 C13.3683471,6.17782981 13.1783744,5.52863203 12.7644189,5.02743801 C12.3504635,4.52624398 11.7488512,4.21703518 11.1003596,4.17216654 C7.78578952,3.96549596 4.48655847,3.56064526 1.22035959,2.95978559 C0.8307482,2.88949163 0.485384459,2.66641281 0.261094651,2.34017309 C0.0368048427,2.01393337 -0.0478095865,1.61158939 0.0260738731,1.22264273 C0.0940772362,0.831850906 0.316638514,0.484929175 0.643506671,0.260207317 C0.970374828,0.0354854591 1.37398815,-0.0480878463 1.76321673,0.0283570137 C11.4077484,1.81074821 21.2972565,1.81074821 30.9417882,0.0283570137 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,0 C44.2339132,0.0149633132 56.9850367,12.7660868 57,28.5 C57,44.2401154 44.2401154,57 28.5,57 C12.7598846,57 0,44.2401154 0,28.5 C0,12.7598846 12.7598846,0 28.5,0 Z M28.5,2.71428571 C14.2589432,2.71428571 2.71428571,14.2589432 2.71428571,28.5 C2.71428571,42.7410568 14.2589432,54.2857143 28.5,54.2857143 C42.7327917,54.2657804 54.2657804,42.7327917 54.2857143,28.5 C54.2857143,14.2589432 42.7410568,2.71428571 28.5,2.71428571 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 65,0 65,65 0,65 0,0",
    stroke: "none",
    fill: "url(#i1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.45995260818634 14.551724073161868) rotate(-44.99999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.13686838e-13,0 9.95238095,0 9.95238095,9.95238095 -1.13686838e-13,9.95238095 -1.13686838e-13,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.142973745962639 20.129738224404537)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.25114413e-16,-2.77555756e-16 32.7241701,-2.77555756e-16 32.7241701,27.6597856 7.25114413e-16,27.6597856 7.25114413e-16,-2.77555756e-16",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 57,0 57,57 0,57 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "85%"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserway);
export default __webpack_public_path__ + "static/media/userway.245c8f7131da99ea3dbaf5cf07e79c99.svg";
export { ForwardRef as ReactComponent };